export default __webpack_public_path__ + "static/media/ic_st_vincent_and_the_grenadines.1df9423b.svg";